import React from 'react';
import {
  FormProvider,
  UseFormReturn,
  FieldValues,
  SubmitHandler,
} from 'react-hook-form';

type Props<T extends FieldValues> = {
  form: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export function Form<T extends FieldValues>({
  form,
  onSubmit,
  children,
  style,
}: Props<T>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} style={style} noValidate>
        {children}
      </form>
    </FormProvider>
  );
}
